import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormLabel,
  Box,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Chip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./Addmember.css";

const FamilyInformation = ({
  formik,
  formData,
  handleChange,
  formErrors,
}) => {
  const houseOptions = [
    { value: "Kuccha", label: "Kuccha" },
    {
      value: "Pucca with stone and mortar",
      label: "Pucca with stone and mortar",
    },
    {
      value: "Pucca with bricks and concrete",
      label: "Pucca with bricks and concrete",
    },
    { value: "Other", label: "Other" },
  ];

  const toiletOptions = [
    {
      value: "Flush toilet with running water",
      label: "Flush toilet with running water",
    },
    {
      value: "Flush toilet without water",
      label: "Flush toilet without water",
    },
    {
      value: "Pit toilet with running water supply",
      label: "Pit toilet with running water supply",
    },
    {
      value: "Pit toilet without water supply",
      label: "Pit toilet without water supply",
    },
    { value: "Other", label: "Other" },
  ];

  const drinkingwaterOptions = [
    { value: "Tap water", label: "Tap water" },
    { value: "Hand pump within house", label: "Hand pump within house" },
    { value: "Hand pump outside of house", label: "Hand pump outside of house" },
    { value: "Well", label: "Well" },
    { value: "Tank", label: "Tank" },
    { value: "River", label: "River" },
    { value: "Pond", label: "Pond" },
    { value: "Other", label: "Other" },
  ];

  const electricityOptions = [
    { value: "Electricity supply", label: "Electricity supply" },
    { value: "Generator", label: "Generator" },
    { value: "Solar power", label: "Solar power" },
    { value: "Kerosene lamp", label: "Kerosene lamp" },
    { value: "Other", label: "Other" },
  ];

  const vehicleOptions = [
    { value: "Motor bike", label: "Motor bike" },
    { value: "Car", label: "Car" },
    { value: "Tractor", label: "Tractor" },
    { value: "Other", label: "Other" },
  ];

  const fuelOptions = [
    { value: "Firewood", label: "Firewood" },
    { value: "Crop residue", label: "Crop residue" },
    { value: "Cow dung cake", label: "Cow dung cake" },
    { value: "Coal", label: "Coal" },
    { value: "Kerosene", label: "Kerosene" },
    { value: "LPG", label: "LPG" },
    { value: "Other", label: "Other" },
  ];

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4 + ITEM_PADDING_TOP,
      },
    },
  };

  return (
    <Accordion
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "4px",
        "&:before": { display: "none" },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: "#f5f5f5",
          fontWeight: 600,
          border: "1px solid #e0e0e0",
        }}
      >
        Family Information
      </AccordionSummary>
      <AccordionDetails>
          <Grid container spacing={4} sx={{ p: 2 }}>
            {/* Number / ID */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center"}}>
                <img
                  src={"/images/id-number.png"}
                  alt="ID Number"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333" }}>
                    Number / ID
                  </FormLabel>
                  <TextField
                    type="text"
                    name="familyInfo.additionalDetails.numberid"
                    value={formData.familyInfo.additionalDetails.numberid || ""}
                    onChange={handleChange}
                    size="small"
                    fullWidth
                    variant="outlined"
                    placeholder="Enter ID"
                    error={Boolean(formErrors?.familyInfo?.additionalDetails?.numberid)}
                    helperText={formErrors?.familyInfo?.additionalDetails?.numberid}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Name of head of the household */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5 , alignItems: "center"}}>
                <img
                  src={"/images/head-of-family.png"}
                  alt="Head of Family"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333" }}>
                    Name of head of the household
                  </FormLabel>
                  <TextField
                    type="text"
                    name="familyInfo.familyHeadName"
                    value={formData.familyInfo.familyHeadName || ""}
                    onChange={handleChange}
                    size="small"
                    fullWidth
                    variant="outlined"
                    placeholder="Enter name"
                    error={Boolean(formErrors?.familyInfo?.familyHeadName)}
                    helperText={formErrors?.familyInfo?.familyHeadName}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Type of House */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5 , alignItems: "center"}}>
                <img
                  src={"/images/type-of-house.png"}
                  alt="Type of House"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Type of House
                  </FormLabel>
                  <Select
                    multiple
                    name="familyInfo.additionalDetails.house"
                    value={Array.isArray(formData.familyInfo.additionalDetails.house) ? formData.familyInfo.additionalDetails.house : []}
                    onChange={(event) => {
                      handleChange({
                        target: {
                          name: "familyInfo.additionalDetails.house",
                          value: event.target.value,
                        },
                      });
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    MenuProps={MenuProps}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "auto",
                        minHeight: "36px",
                        padding: "4px 6px",
                      },
                    }}
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return "Select house type";
                      }
                      return (
                        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} size="small" />
                          ))}
                        </Box>
                      );
                    }}
                    error={Boolean(formErrors?.familyInfo?.additionalDetails?.house)}
                  >
                    {houseOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={formData.familyInfo.additionalDetails.house?.includes(option.value) || false}
                          size="small"
                        />
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {formData.familyInfo.additionalDetails.house?.includes(
                    "Other"
                  ) && (
                    <TextField
                      type="text"
                      placeholder="If other, specify"
                      name="familyInfo.additionalDetails.houseOther"
                      value={
                        formData.familyInfo.additionalDetails.houseOther || ""
                      }
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mt: 1,
                        "& .MuiOutlinedInput-root": {
                          height: "36px",
                        },
                      }}
                    />
                  )}
                  {formErrors?.familyInfo?.additionalDetails?.house && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.familyInfo.additionalDetails.house}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Availability of Toilet */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <img
                  src={"/images/availability-of-toilet.png"}
                  alt="Toilet"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Availability of Toilet
                  </FormLabel>
                  <Select
                    multiple
                    name="familyInfo.additionalDetails.toilet"
                    value={Array.isArray(formData.familyInfo.additionalDetails.toilet) ? formData.familyInfo.additionalDetails.toilet : []}
                    onChange={(event) => {
                      handleChange({
                        target: {
                          name: "familyInfo.additionalDetails.toilet",
                          value: event.target.value,
                        },
                      });
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    MenuProps={MenuProps}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "auto",
                        minHeight: "36px",
                        padding: "4px 6px",
                      },
                    }}
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return "Select toilet type";
                      }
                      return (
                        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} size="small" />
                          ))}
                        </Box>
                      );
                    }}
                    error={Boolean(formErrors?.familyInfo?.additionalDetails?.toilet)}
                  >
                    {toiletOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={formData.familyInfo.additionalDetails.toilet?.includes(option.value) || false}
                          size="small"
                        />
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {formData.familyInfo.additionalDetails.toilet?.includes(
                    "Other"
                  ) && (
                    <TextField
                      type="text"
                      placeholder="If other, specify"
                      name="familyInfo.additionalDetails.toiletOther"
                      value={
                        formData.familyInfo.additionalDetails.toiletOther || ""
                      }
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mt: 1,
                        "& .MuiOutlinedInput-root": {
                          height: "36px",
                        },
                      }}
                    />
                  )}
                  {formErrors?.familyInfo?.additionalDetails?.toilet && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.familyInfo.additionalDetails.toilet}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Source of Drinking Water */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <img
                  src={"/images/source-of-drinking-water.png"}
                  alt="Drinking Water"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Source of Drinking Water
                  </FormLabel>
                  <Select
                    multiple
                    name="familyInfo.additionalDetails.water"
                    value={Array.isArray(formData.familyInfo.additionalDetails.water) ? formData.familyInfo.additionalDetails.water : []}
                    onChange={(event) => {
                      handleChange({
                        target: {
                          name: "familyInfo.additionalDetails.water",
                          value: event.target.value,
                        },
                      });
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    MenuProps={MenuProps}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "auto",
                        minHeight: "36px",
                        padding: "4px 6px",
                      },
                    }}
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return "Select water source";
                      }
                      return (
                        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} size="small" />
                          ))}
                        </Box>
                      );
                    }}
                    error={Boolean(formErrors?.familyInfo?.additionalDetails?.water)}
                  >
                    {drinkingwaterOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={formData.familyInfo.additionalDetails.water?.includes(option.value) || false}
                          size="small"
                        />
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {formData.familyInfo.additionalDetails.water?.includes(
                    "Other"
                  ) && (
                    <TextField
                      type="text"
                      placeholder="If other, specify"
                      name="familyInfo.additionalDetails.waterOther"
                      value={
                        formData.familyInfo.additionalDetails.waterOther || ""
                      }
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mt: 1,
                        "& .MuiOutlinedInput-root": {
                          height: "36px",
                        },
                      }}
                    />
                  )}
                  {formErrors?.familyInfo?.additionalDetails?.water && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.familyInfo.additionalDetails.water}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Availability of Electricity */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <img
                  src={"/images/availability-of-electricity.png"}
                  alt="Electricity"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Availability of Electricity
                  </FormLabel>
                  <Select
                    multiple
                    name="familyInfo.additionalDetails.electricity"
                    value={Array.isArray(formData.familyInfo.additionalDetails.electricity) ? formData.familyInfo.additionalDetails.electricity : []}
                    onChange={(event) => {
                      handleChange({
                        target: {
                          name: "familyInfo.additionalDetails.electricity",
                          value: event.target.value,
                        },
                      });
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    MenuProps={MenuProps}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "auto",
                        minHeight: "36px",
                        padding: "4px 6px",
                      },
                    }}
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return "Select electricity source";
                      }
                      return (
                        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} size="small" />
                          ))}
                        </Box>
                      );
                    }}
                    error={Boolean(formErrors?.familyInfo?.additionalDetails?.electricity)}
                  >
                    {electricityOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={formData.familyInfo.additionalDetails.electricity?.includes(option.value) || false}
                          size="small"
                        />
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {formData.familyInfo.additionalDetails.electricity?.includes(
                    "Other"
                  ) && (
                    <TextField
                      type="text"
                      placeholder="If other, specify"
                      name="familyInfo.additionalDetails.electricityOther"
                      value={
                        formData.familyInfo.additionalDetails
                          .electricityOther || ""
                      }
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mt: 1,
                        "& .MuiOutlinedInput-root": {
                          height: "36px",
                        },
                      }}
                    />
                  )}
                  {formErrors?.familyInfo?.additionalDetails?.electricity && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.familyInfo.additionalDetails.electricity}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Motorised Vehicle */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5 , alignItems: "center"}}>
                <img
                  src={"/images/motorised-vehicle.png"}
                  alt="Vehicle"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Motorised Vehicle
                  </FormLabel>
                  <Select
                    multiple
                    name="familyInfo.additionalDetails.vehicle"
                    value={Array.isArray(formData.familyInfo.additionalDetails.vehicle) ? formData.familyInfo.additionalDetails.vehicle : []}
                    onChange={(event) => {
                      handleChange({
                        target: {
                          name: "familyInfo.additionalDetails.vehicle",
                          value: event.target.value,
                        },
                      });
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    MenuProps={MenuProps}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "auto",
                        minHeight: "36px",
                        padding: "4px 6px",
                      },
                    }}
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return "Select vehicle";
                      }
                      return (
                        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} size="small" />
                          ))}
                        </Box>
                      );
                    }}
                    error={Boolean(formErrors?.familyInfo?.additionalDetails?.vehicle)}
                  >
                    {vehicleOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={formData.familyInfo.additionalDetails.vehicle?.includes(option.value) || false}
                          size="small"
                        />
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {formData.familyInfo.additionalDetails.vehicle?.includes(
                    "Other"
                  ) && (
                    <TextField
                      type="text"
                      placeholder="If other, specify"
                      name="familyInfo.additionalDetails.vehicleOther"
                      value={
                        formData.familyInfo.additionalDetails.vehicleOther || ""
                      }
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mt: 1,
                        "& .MuiOutlinedInput-root": {
                          height: "36px",
                        },
                      }}
                    />
                  )}
                  {formErrors?.familyInfo?.additionalDetails?.vehicle && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.familyInfo.additionalDetails.vehicle}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Type of Fuel Used for Cooking */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <img
                  src={"/images/fuel.png"}
                  alt="Fuel"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Type of Fuel Used for Cooking
                  </FormLabel>
                  <Select
                    multiple
                    name="familyInfo.additionalDetails.fuel"
                    value={Array.isArray(formData.familyInfo.additionalDetails.fuel) ? formData.familyInfo.additionalDetails.fuel : []}
                    onChange={(event) => {
                      handleChange({
                        target: {
                          name: "familyInfo.additionalDetails.fuel",
                          value: event.target.value,
                        },
                      });
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    MenuProps={MenuProps}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "auto",
                        minHeight: "36px",
                        padding: "4px 6px",
                      },
                    }}
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return "Select fuel type";
                      }
                      return (
                        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} size="small" />
                          ))}
                        </Box>
                      );
                    }}
                    error={Boolean(formErrors?.familyInfo?.additionalDetails?.fuel)}
                  >
                    {fuelOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={formData.familyInfo.additionalDetails.fuel?.includes(option.value) || false}
                          size="small"
                        />
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {formData.familyInfo.additionalDetails.fuel?.includes(
                    "Other"
                  ) && (
                    <TextField
                      type="text"
                      placeholder="If other, specify"
                      name="familyInfo.additionalDetails.fuelOther"
                      value={
                        formData.familyInfo.additionalDetails.fuelOther || ""
                      }
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mt: 1,
                        "& .MuiOutlinedInput-root": {
                          height: "36px",
                        },
                      }}
                    />
                  )}
                  {formErrors?.familyInfo?.additionalDetails?.fuel && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.familyInfo.additionalDetails.fuel}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Religion */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <img
                  src={"/images/religion.png"}
                  alt="Religion"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Religion
                  </FormLabel>
                  <Select
                    name="individualInfo.additionalDetails.religion"
                    value={
                      formData.individualInfo.additionalDetails.religion || ""
                    }
                    onChange={handleChange}
                    variant="outlined"
                    fullWidth
                    size="small"
                    MenuProps={MenuProps}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    }}
                    error={Boolean(formErrors?.individualInfo?.additionalDetails?.religion)}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="Hindu">Hindu</MenuItem>
                    <MenuItem value="Muslim">Muslim</MenuItem>
                    <MenuItem value="Christian">Christian</MenuItem>
                    <MenuItem value="Sikh">Sikh</MenuItem>
                    <MenuItem value="Buddhist">Buddhist</MenuItem>
                    <MenuItem value="Jain">Jain</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                  {formData.individualInfo.additionalDetails.religion ===
                    "Other" && (
                    <TextField
                      type="text"
                      placeholder="If other, specify"
                      name="individualInfo.additionalDetails.religionOther"
                      value={
                        formData.individualInfo.additionalDetails
                          .religionOther || ""
                      }
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mt: 1,
                        "& .MuiOutlinedInput-root": {
                          height: "36px",
                        },
                      }}
                    />
                  )}
                  {formErrors?.individualInfo?.additionalDetails?.religion && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.individualInfo.additionalDetails.religion}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Caste */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <img
                  src={"/images/caste.png"}
                  alt="Caste"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Caste
                  </FormLabel>
                  <Select
                    name="individualInfo.additionalDetails.caste"
                    value={
                      formData.individualInfo.additionalDetails.caste || ""
                    }
                    onChange={handleChange}
                    variant="outlined"
                    fullWidth
                    size="small"
                    MenuProps={MenuProps}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    }}
                    error={Boolean(formErrors?.individualInfo?.additionalDetails?.caste)}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="General">General</MenuItem>
                    <MenuItem value="SC">SC</MenuItem>
                    <MenuItem value="ST">ST</MenuItem>
                    <MenuItem value="OBC">OBC</MenuItem>
                    <MenuItem value="Do not Know">Do not Know</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                  {formData.individualInfo.additionalDetails.caste ===
                    "Other" && (
                    <TextField
                      type="text"
                      placeholder="If other, specify"
                      name="individualInfo.additionalDetails.casteOther"
                      value={
                        formData.individualInfo.additionalDetails.casteOther ||
                        ""
                      }
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mt: 1,
                        "& .MuiOutlinedInput-root": {
                          height: "36px",
                        },
                      }}
                    />
                  )}
                  {formErrors?.individualInfo?.additionalDetails?.caste && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.individualInfo.additionalDetails.caste}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Contact Details */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <img
                  src={"/images/contact-details.png"}
                  alt="Contact"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Contact Details
                  </FormLabel>
                  <TextField
                    type="text"
                    name="familyInfo.contactDetail"
                    value={formData.familyInfo.contactDetail || null}
                    onChange={handleChange}
                    size="small"
                    fullWidth
                    variant="outlined"
                    placeholder="Enter contact"
                    error={Boolean(formErrors?.familyInfo?.contactDetail)}
                    helperText={formErrors?.familyInfo?.contactDetail}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Ration Card */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5 , alignItems: "center"}}>
                <img
                  src={"/images/rationcard.png"}
                  alt="Ration Card"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Ration Card
                  </FormLabel>
                  <TextField
                    type="text"
                    name="familyInfo.additionalDetails.ration"
                    value={formData.familyInfo.additionalDetails.ration || ""}
                    onChange={handleChange}
                    size="small"
                    fullWidth
                    variant="outlined"
                    placeholder="Enter ration card number"
                    error={Boolean(formErrors?.familyInfo?.additionalDetails?.ration)}
                    helperText={formErrors?.familyInfo?.additionalDetails?.ration}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* House Ownership Status */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5 , alignItems: "center"}}>
                <img
                  src={"/images/house-ownership-status.png"}
                  alt="House Ownership"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    House Ownership Status
                  </FormLabel>
                  <Select
                    name="familyInfo.additionalDetails.houseOwnershipStatus"
                    value={
                      formData.familyInfo.additionalDetails
                        .houseOwnershipStatus || ""
                    }
                    onChange={handleChange}
                    variant="outlined"
                    fullWidth
                    size="small"
                    MenuProps={MenuProps}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    }}
                    error={Boolean(formErrors?.familyInfo?.additionalDetails?.houseOwnershipStatus)}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="Rent">Rent</MenuItem>
                    <MenuItem value="Own">Own</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                  {formErrors?.familyInfo?.additionalDetails?.houseOwnershipStatus && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.familyInfo.additionalDetails.houseOwnershipStatus}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Address Information */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5 , alignItems: "center"}}>
                <img
                  src={"/images/address-info.png"}
                  alt="Address"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Address Information
                  </FormLabel>
                  <TextField
                    type="text"
                    name="familyInfo.addressInfo.addressDetails"
                    value={formData.familyInfo.addressInfo.addressDetails || ""}
                    onChange={handleChange}
                    size="small"
                    fullWidth
                    variant="outlined"
                    placeholder="Enter address"
                    error={Boolean(formErrors?.familyInfo?.addressInfo?.addressDetails)}
                    helperText={formErrors?.familyInfo?.addressInfo?.addressDetails}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Landmark */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5 , alignItems: "center"}}>
                <img
                  src={"/images/landmark.png"}
                  alt="Landmark"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Landmark
                  </FormLabel>
                  <TextField
                    type="text"
                    name="familyInfo.addressInfo.landmark"
                    value={formData.familyInfo.addressInfo.landmark || ""}
                    onChange={handleChange}
                    size="small"
                    fullWidth
                    variant="outlined"
                    placeholder="Enter landmark"
                    error={Boolean(formErrors?.familyInfo?.addressInfo?.landmark)}
                    helperText={formErrors?.familyInfo?.addressInfo?.landmark}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* APL/BPL */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5 , alignItems: "center"}}>
                <img
                  src={"/images/apl-bpl.png"}
                  alt="APL/BPL"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    APL/BPL
                  </FormLabel>
                  <Box sx={{ mt: 0.5 }}>
                    <RadioGroup
                      row
                      name="familyInfo.additionalDetails.rationCardAPL"
                      value={
                        formData.familyInfo.additionalDetails.rationCardAPL ===
                        true
                          ? "true"
                          : formData.familyInfo.additionalDetails
                              .rationCardAPL === false
                          ? "false"
                          : ""
                      }
                      onChange={(e) => {
                        handleChange({
                          target: {
                            name: "familyInfo.additionalDetails.rationCardAPL",
                            value: e.target.value === "true" ? true : false,
                          },
                        });
                      }}
                    >
                      <FormControlLabel
                        value="true"
                        control={<Radio />}
                        label="APL"
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label="BPL"
                      />
                    </RadioGroup>
                  </Box>
                  {formErrors?.familyInfo?.additionalDetails?.rationCardAPL && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.familyInfo.additionalDetails.rationCardAPL}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Annual Household Income */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Box sx={{ display: "flex", gap: 1.5 , alignItems: "center"}}>
                <img
                  src={"/images/annual-income.png"}
                  alt="Income"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                    Annual Household Income
                  </FormLabel>
                  <Select
                    name="familyInfo.additionalDetails.income"
                    value={
                      formData.familyInfo.additionalDetails.income || ""
                    }
                    onChange={handleChange}
                    variant="outlined"
                    fullWidth
                    size="small"
                    MenuProps={MenuProps}
                    sx={{
                      mt: 0.5,
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    }}
                    error={Boolean(formErrors?.familyInfo?.additionalDetails?.income)}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="0-10,000">0-10,000</MenuItem>
                    <MenuItem value="10,000-20,000">10,000-20,000</MenuItem>
                    <MenuItem value="20,000-30,000">20,000-30,000</MenuItem>
                    <MenuItem value="30,000-50,000">30,000-50,000</MenuItem>
                    <MenuItem value="50,000-100,000">50,000-100,000</MenuItem>
                    <MenuItem value="100,000-2,00,000">
                      100,000-2,00,000
                    </MenuItem>
                    <MenuItem value="2,00,000">&gt;2,00,000</MenuItem>
                    <MenuItem value="Do not know">Do not know</MenuItem>
                  </Select>
                  {formErrors?.familyInfo?.additionalDetails?.income && (
                    <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                      {formErrors.familyInfo.additionalDetails.income}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default FamilyInformation;
